export default __webpack_public_path__ + "static/media/calendar.e620049b.svg";